import _classCallCheck from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { StorageRetryPolicy, StorageRetryPolicyType } from "./policies/StorageRetryPolicy";
export { StorageRetryPolicyType, StorageRetryPolicy };
/**
 * StorageRetryPolicyFactory is a factory class helping generating {@link StorageRetryPolicy} objects.
 */

export var StorageRetryPolicyFactory = /*#__PURE__*/function () {
  /**
   * Creates an instance of StorageRetryPolicyFactory.
   * @param retryOptions -
   */
  function StorageRetryPolicyFactory(retryOptions) {
    _classCallCheck(this, StorageRetryPolicyFactory);

    this.retryOptions = retryOptions;
  }
  /**
   * Creates a StorageRetryPolicy object.
   *
   * @param nextPolicy -
   * @param options -
   */


  _createClass(StorageRetryPolicyFactory, [{
    key: "create",
    value: function create(nextPolicy, options) {
      return new StorageRetryPolicy(nextPolicy, options, this.retryOptions);
    }
  }]);

  return StorageRetryPolicyFactory;
}();